<div id="{{idTable}}">
  <table class="table table-striped" datatable [dtOptions]="dtOptions" style="width: 100%;">
    <thead>
      <tr *ngIf="tableConfig.headerColumn">
        <th *ngFor="let columnHeader of tableHeaderColumns; let i = index" [attr.colspan]="columnHeader.columSpan" class="row-header" [ngClass]="{'bg-primary': columnHeader.name && i%2==0, 'bg-secondary': columnHeader.name && i%2==1}">
          {{columnHeader['name']}}
        </th>
      </tr>
      <tr>
        <th class="checkbox-col" *ngIf="tableConfig.enableCheckbox">
          <label class="container-cb-listing" id="cs-table-common-check-mark-all-id">
            <input type="checkbox" [(ngModel)]="isAllSelected" (change)="checkAllRecord($event)" [disabled]="tableConfig.isDisableCheckbox">
            <span class="check-mark-listing"></span>
          </label>
        </th>
        <th>No.</th>
        <th *ngFor="let column of tableColumns" >
          <span [ngClass]="{'writing-vertical': tableConfig.headerWritingVertical, 'no-wrap-text': true}">{{column['name']}}</span>
        </th>
      </tr>
    </thead>
    <tbody *ngIf="contents?.length > 0">
      <tr *ngFor="let rowData of contents; let pointIndex = index" [class.enable-click]="tableConfig.isClickRow">
        <td *ngIf="tableConfig.enableCheckbox">
          <label class="container-cb-listing" [attr.id]="'cs-table-common-check-mark-'+pointIndex+'-id'">
            <input type="checkbox" [(ngModel)]="selectedValues[getRowId(rowData)]" [disabled]="tableConfig.isDisableCheckbox"
              (change)="checkOneRecord(rowData, $event)">
            <span class="check-mark-listing"></span>
          </label>
        </td>
        <td class="font-weight-bold">{{pointIndex + 1}}</td>
        <td *ngFor="let col of tableColumns" (click)="onClickRow(rowData)">
          <ng-container [ngSwitch]="col['type']">
            <ng-container *ngSwitchCase="'link'">
              <ng-container *ngIf="!tableConfig.isDisableLink; else notLink">
                <span (click)="onEdit(rowData)" class="font-weight-bold column-name no-wrap-text" [attr.id]="col.data + '-' + pointIndex + '-id'" lTooltip>
                  {{rowData[col['data']]}}
                </span>
              </ng-container>
              <ng-template #notLink>
                 <span lTooltip>
                  {{rowData[col['data']]}}
                </span>
              </ng-template>
            </ng-container>
            <ng-container *ngSwitchCase="'navigate-link'">
              <span (click)="navigatePage(col, rowData)" class="font-weight-bold column-name no-wrap-text" lTooltip>
                {{rowData[col['data']]}}
              </span>
            </ng-container>

            <ng-container *ngSwitchCase="'date'">
              <!-- for edit modal -->
              <span>{{ formatDate(rowData[col['data']])}}</span>
            </ng-container>

            <ng-container *ngSwitchCase="'datetime'">
              <!-- for edit modal -->
              <span>{{ formatDateTime(rowData[col['data']])}}</span>
            </ng-container>

            <ng-container *ngSwitchCase="'number'">
              <!-- for edit modal -->
              <span>
                {{rowData[col['data']] | number}}
              </span>
            </ng-container>

            <ng-container *ngSwitchCase="'boolean'">
              <!-- for edit modal -->
              <span>
                {{rowData[col['data']] ? 'Yes' : 'No'}}
              </span>
            </ng-container>

            <ng-container *ngSwitchCase="'currency'">
              <!-- for edit modal -pw-location-overview-->
              <span>
                {{ rowData[col['data']] | number:'.0-14'}}
              </span>
            </ng-container>

            <ng-container *ngSwitchCase="'status'">
              <div class="status-info">
                <span class="badge badge-pill text-uppercase"
                     [ngClass]="getStatusCssClass(rowData[col['data']])">
                {{ rowData[col['data']] | status }}
              </span>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'password'">
              <div class="d-flex justify-content-between">
                <input disabled style="border: none" class="status-info" id="password-field-{{pointIndex}}" type="password" [value]="rowData[col['data']]"> <i toggle="#password-field-{{pointIndex}}" style="cursor: pointer" class="fa fa-fw fa-eye toggle-password-{{pointIndex}}" (click)="togglePassword(pointIndex)"></i>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'error'">
              <div *ngIf="reformatData(col, rowData) === '1'" class="error-info">
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'edit'">
              <button class="btn btn-sm btn-outline-success" (click)="onEditRow(col, rowData)"><i class="pw-edit" aria-hidden="true"></i> Sửa</button>
            </ng-container>

            <ng-container *ngSwitchDefault>
              <span lTooltip class="no-wrap-text" [attr.id]="col.data + '-' + pointIndex + '-id'">
                {{reformatData(col, rowData)}}
              </span>
            </ng-container>
          </ng-container>
      </td>
    </tr>
    </tbody>
    <tbody></tbody>
    <tbody *ngIf="contents?.length === 0">
    <tr>
      <td [attr.colspan]="this.tableColumns + 1" class="bg-white no-data">
        <div class="dataTables_processing card" style="margin-top: -50px" *ngIf="!processing">
          <img class="no-result-found" src="assets/img/ic-search-noresult.svg" alt="No Result Found">
          <p class="text-muted mt-2" id="cs-table-common-no-result-id">Không có dữ liệu</p>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>
